module.exports = __webpack_public_path__ + "static/media/accordion-circle-closed.0ce63219.svg";